import { useRef } from 'react';
import { useTheme } from '@material-ui/core/styles';
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';

import useConfirmationDialogV2 from '../../../../../../commons/dialogV2/useConfirmationDialogV2';

function useDowngradePlanDialog () {
    const theme = useTheme();
    const onConfirmRef = useRef(() => {});

    const { openDialog, renderDialog } = useConfirmationDialogV2({
        icon: HelpOutlineOutlinedIcon,
        accentColor: theme.palette.error.main,
        confirmButtonColor: theme.palette.error.main,
        showSecondaryButton: true,
        showPrimaryButton: true,
        confirmLabel: 'CONTINUE',
        cancelLabel: 'CLOSE',
        onConfirm: () => onConfirmRef.current(),
    });

    function requestDowngradeConfirmation ({ title, message }, onConfirm) {
        onConfirmRef.current = onConfirm;
        openDialog(title, message);
    }

    return {
        requestDowngradeConfirmation,
        renderDowngradeDialog: renderDialog,
    };
}

export default useDowngradePlanDialog;
